var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_507_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 0C236.118 0 220 16.1178 220 36V476C220 495.882 236.118 512 256 512C275.882 512 292 495.882 292 476V36C292 16.1178 275.882 0 256 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 164C110 144.118 126.118 128 146 128C165.882 128 182 144.118 182 164V348C182 367.882 165.882 384 146 384C126.118 384 110 367.882 110 348V164Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 228C0 208.118 16.1178 192 36 192C55.8823 192 72 208.118 72 228V284C72 303.882 55.8823 320 36 320C16.1178 320 0 303.882 0 284V228Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 116C330 96.1178 346.118 80 366 80C385.882 80 402 96.1178 402 116V396C402 415.882 385.882 432 366 432C346.118 432 330 415.882 330 396V116Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 292C495.882 292 512 275.882 512 256C512 236.118 495.882 220 476 220C456.118 220 440 236.118 440 256C440 275.882 456.118 292 476 292Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_507_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbol);
export default __webpack_public_path__ + "static/media/symbol.897c87f03dcf870d24f3e772ae53bf12.svg";
export { ForwardRef as ReactComponent };